import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Link from "@material-ui/core/Link"
import {Link as RouterLink} from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import {withStyles} from "@material-ui/core"
import ClassData from './class_data'

const style = theme => ({
  link: {
    // margin: theme.spacing(2),
  }
});

class ClassList extends Component {
  render() {
    const { classes } = this.props;

    const classList = Object.keys(ClassData).sort().map((k) =>
      <Grid item>
        <Link key={k}
              component={RouterLink}
              to={`/help/classes/${k}`}
              className={classes.link}>{ClassData[k].name}</Link>
      </Grid>)

    return (
      <Grid container direction={'row'} spacing={3}>
        {classList}
      </Grid>
    );
  }
}

ClassList.propTypes = {};

ClassList = withStyles(style)(ClassList);

export default ClassList;